<h2>Responsáveis pela Inscrição #{{ data.id }}</h2>
<hr />
<mat-dialog-content>
  <div class="conteudo" fxLayout="column" fxLayoutGap="5px" fxFlex="100%" fxFill>
    <mat-form-field appearance="outline">
      <mat-label>Discente</mat-label>
      <input matInput [value]="data.nome" disabled="true" />
    </mat-form-field>

    <mat-form-field appearance="outline" floatLabel="always">
      <mat-label>CPFs dos responsaveis</mat-label>
      <mat-chip-grid #responsaveisChipList>
        <mat-chip-row *ngFor="let cpf of responsaveisChips" (removed)="removeChip(cpf)">
          {{ cpf }}
          <button matChipRemove>
            <mat-icon>cancel</mat-icon>
          </button>
        </mat-chip-row>
        <input [formControl]="matChipFC" style="display: none" />
      </mat-chip-grid>
    </mat-form-field>

    <mat-form-field appearance="outline" floatLabel="always">
      <mat-label>Adicionar responsável</mat-label>
      <input
        matInput
        mask="000.000.000-00"
        [placeholder]="chipPlaceHolder"
        [matChipInputFor]="responsaveisChipList"
        [matChipInputSeparatorKeyCodes]="chipsSeparatorKeys"
        [matChipInputAddOnBlur]="true"
        (matChipInputTokenEnd)="addChip($event)"
        [formControl]="responsaveisChipListFC" />
      <mat-error> {{ erroChipsMsg }} </mat-error>
    </mat-form-field>
  </div>
</mat-dialog-content>
<div mat-dialog-actions fxLayoutAlign="end">
  <button mat-button (click)="close()">Fechar</button>
</div>
